import React, { useState, useEffect } from 'react';
import { makeStyles, TextField } from '@material-ui/core';
import SubmitButton from 'components/SubmitButton';
import SimpleForm from 'components/SimpleForm';
import withAuthorization from 'components/Session/withAuthorization';
import TextError from 'components/TextError';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles(({ spacing, status, theme }) => ({
  root: {
    flexGrow: 1,
  },
  successMessage: {
    color: status.success,
    maxWidth: '100%',
    display: 'inline-block',
  }
}));

const ProfileUpdate = ({firstName, lastName, handleProfile,onChanged, error,profileMessage}) => {
    const classes = useStyles();
    return (
        <SimpleForm title="" onSubmit={handleProfile}>
            {profileMessage &&         
                <Typography variant="h6" className={classes.successMessage} align="center" gutterBottom>
                    {profileMessage}
                </Typography>    
            }   
            {error && <TextError>{error}</TextError>} 
            <TextField
              label="First Name"
              fullWidth
              value={firstName}
              type="text"
              onChange={e => onChanged('firstName', e.target.value)}
              margin="normal"
            />
            <TextField
              label="Last Name"
              fullWidth
              value={lastName}
              type="text"
              onChange={e => onChanged('lastName', e.target.value)}
              margin="normal"
            />
            <SubmitButton size="small">Submit</SubmitButton>
        </SimpleForm>
    );
};

export default withAuthorization()(ProfileUpdate);

